import clsx from 'clsx';
import {
  AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
  AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
} from '../constants';

export function AuthButtonSkeleton() {
  return (
    <div
      className={clsx(
        'h-[45px]',
        'bg-gray-100',
        'animate-pulse',
        'ease-in-out',
        AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
        AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
      )}
    />
  );
}
